import { StateTime } from '../../../WidgetBlocks/types';
import { TypeKeys, WidgetBlockAction } from './types';

type SetTimeAction = WidgetBlockAction<TypeKeys.SET_TIME, StateTime>;

const setTime = (widgetId: string | null, instanceId: string | null, iso8601: string, timezone: string): SetTimeAction => ({
    type: TypeKeys.SET_TIME,
    payload: {
        widgetId,
        instanceId,
        iso8601,
        timezone,
    },
});

export default setTime;
export { SetTimeAction };
